export default "__VITE_ASSET__BrnjGVD2__"